// extracted by mini-css-extract-plugin
export var border = "_19-8";
export var brand = "_19-t";
export var button = "_19-l";
export var center = "_19-a";
export var centered = "_19-6";
export var closeButton = "_19-c";
export var disabledWrapper = "_19-m";
export var error = "_19-p";
export var extraLarge = "_19-4";
export var extraSmall = "_19-1";
export var fill = "_19-i";
export var footer = "_19-h";
export var footerAction = "_19-j";
export var footerButtons = "_19-k";
export var header = "_19-7";
export var headerWithClose = "_19-d";
export var icon = "_19-o";
export var info = "_19-s";
export var inline = "_19-9";
export var large = "_19-3";
export var main = "_19-e";
export var modal = "_19-0";
export var nearFull = "_19-5";
export var neutral = "_19-u";
export var noPadding = "_19-g";
export var none = "_19-v";
export var scrollable = "_19-f";
export var small = "_19-2";
export var success = "_19-r";
export var tight = "_19-n";
export var titleIcon = "_19-b";
export var warn = "_19-q";